import React from "react";
import "./nav.css";
import { Link } from "react-router-dom";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import PersonIcon from "@mui/icons-material/Person";
import WorkRoundedIcon from "@mui/icons-material/WorkRounded";
import LaptopChromebookRoundedIcon from "@mui/icons-material/LaptopChromebookRounded";
import ChatRoundedIcon from "@mui/icons-material/ChatRounded";
import { useState } from "react";
function Nav() {
  const [activeNav, setActiveNav] = useState("home");

  return (
    <nav>
      <a
        href="#home"
        onClick={() => setActiveNav("home")}
        className={activeNav === "home" ? "active" : ""}
      >
        <HomeRoundedIcon />
      </a>
      <a
        href="#about"
        onClick={() => setActiveNav("about")}
        className={activeNav === "about" ? "active" : ""}
      >
        <PersonIcon />
      </a>
      <a
        href="#experience"
        onClick={() => setActiveNav("experience")}
        className={activeNav === "experience" ? "active" : ""}
      >
        <WorkRoundedIcon />
      </a>
      <Link
        to="/projects"
        onClick={() => setActiveNav("services")}
        className={activeNav === "services" ? "active" : ""}
      >
        <LaptopChromebookRoundedIcon />
      </Link>
      <a
        href="#contacts"
        onClick={() => setActiveNav("contacts")}
        className={activeNav === "contacts" ? "active" : ""}
      >
        <ChatRoundedIcon />
      </a>
    </nav>
  );
}

export default Nav;
